<template>
	<div class="root">
		<img class="ldt" v-lazy="require('../../assets/imgs/20250903/ldt/pc_index_back.png')"  />
		<div class="content">
			<el-row class="one">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/ldt_title1.png')" />
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="5" class="left">
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/01.png')" />
						<p>
							唤醒AI对话，支持自然语言口令控制，快速匹配用户需求，实现“所说即所得”的无缝体验。
						</p>
					</div>
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/02.png')" />
						<p>
							从教育场景：小学至高总教材同步课文、诗词鉴赏、英语课文，到各类文化场景：红色经典、名著选段、传统文化科普文章。
						</p>
					</div>
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/03.png')" />
						<p>
							界面操作简洁，智能评测自动纠错评分。作品活动一键分享，家长孩子轻松互动。
						</p>
					</div>
				</el-col>
				<el-col :span="1">&nbsp;</el-col>
				<el-col :span="8">
					<img v-lazy="require('../../assets/imgs/20250903/ldt/ldt.png')" width="100%"/>
				</el-col>
				<el-col :span="1">&nbsp;</el-col>
				<el-col :span="5" class="right">
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/04.png')" />
						<p>
							普通话测评：对接国家语委标准，检测声调、连读、情感表达 英语测评：基于CEFR框架，评估发音准确度、流利度、语法使用 教材背诵
						</p>
					</div>
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/05.png')" />
						<p>
							疏导模块：专业心理测试（抑郁/焦虑/压力量表）、科普文章库 舒压模块：ASMR自然声库、冥想引导音频、心灵树洞 干预模块：心理
						</p>
					</div>
					<div>
						<img v-lazy="require('../../assets/imgs/20250903/ldt/06.png')" />
						<p>
							设备管理：远程监控设备状态、资源更新、故障预警 效果分析：生成机构数据报告
						</p>
					</div>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="24" class="bottem">
					<img v-lazy="require('../../assets/imgs/ldtback.png')" />
					<el-row class="iconlist">
						<el-col :span="4">&nbsp;</el-col>
						<el-col :span="16">
							<el-row :gutter="20">
								<el-col :span="24 / tabs.length" v-for="v, i in tabs" :key="i">
									<img v-lazy="v.icon" />
									<p>{{v.name}}</p>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="4">&nbsp;</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row class="two">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/ldt/ldt_title2.png')" />
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="20">
					<div class="block">
						<img
							v-lazy="require('../../assets/imgs/swiperback1.png')"
							class="swiperback"
						/>
						<el-carousel
							trigger="click"
							:loop="true"
							height="900px"
							indicator-position="outside"
						>
							<el-carousel-item class="carousel-item" v-for="v, i in carouselList" :key="i">
								<img v-lazy="v.cover" />
								<p class="name">&nbsp;</p>
								<p class="type">{{ v.name }}</p>
							</el-carousel-item>
						</el-carousel>
					</div>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
			<el-row class="three">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/ldt_title3.png')" />
				</el-col>
				<el-col :span="4">&nbsp;</el-col>
				<el-col :span="16">
					<el-table
						stripe
						id="table"
						style="width: 100%"
						:data="tableData">
						<el-table-column prop="name" label="" style="width:50%">
						</el-table-column>
						<el-table-column prop="data" label="" style="width:50%">
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="4">&nbsp;</el-col>
			</el-row>
			<el-row class="four">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/ldt/ldt_title4.png')" />
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="20">
					<div>
						<el-carousel
							type="card"
							trigger="click"
							:loop="true"
							height="500px"
							indicator-position="outside">
							<el-carousel-item class="case-item" v-for="v, i in caseList" :key="i">
								<img v-lazy="v.cover" />
							</el-carousel-item>
						</el-carousel>
					</div>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: "pcLdt",
		data() {
			return {
				msg: "这是PC的朗读亭宣传页面",
				tableData: [
					{ name:"设备主体",data:"朗读亭一台（含空调、通风系统、灯光、射灯、玻璃）"},
					{ name: "V G V:", data: "最高可支持1920*1080@fps" },
					{ name: "操作系统:", data: "安卓系统" },
					{ name: "C P U:", data: "触摸点播系统（屏）1 个，21.5液晶\n影像字幕显示屏1 个，32寸液晶\n 主控机1 个" },
					{ name: "显示部分:", data: "安卓系统" },
					{ name: "产品尺寸:", data: "1.26*1.56*2.70M" },
					{ name: "额定电源:", data: "AC220V 50HZ" },
					{ name: "无线连接:", data: "支持网线、WIFI" },
					{ name: "额定功率:", data: "整机为800W,包含空调和通风系统" },
					{ name: "屏幕类型:", data: "主显示器分辨率1920*1080\n触摸屏分辨率，1920*1080" },
					{ name: "软件升级:", data: "支持本地升级/OTA升级" },
					{ name: "设备附件:", data: "专业电容麦克风2个\n专业监听头戴式耳机2个\n空调遥控器1个\n复古座椅2个\n小吧台2个" },
					{ name: "附加功能:", data: "臭氧消毒" }
				],
        tabs: [
          { name: "本地特色", icon: require("../../assets/imgs/20250903/ldt/bdts.png") },
          { name: "活动", icon: require("../../assets/imgs/20250903/ldt/hd.png") },
          { name: "绘本朗读", icon: require("../../assets/imgs/20250903/ldt/hbld.png") },
          { name: "配音", icon: require("../../assets/imgs/20250903/ldt/py.png") },
          { name: "英文评测", icon: require("../../assets/imgs/20250903/ldt/ywpc.png") },
          { name: "中文评测", icon: require("../../assets/imgs/20250903/ldt/zwpc.png") },
          { name: "背诵", icon: require("../../assets/imgs/20250903/ldt/bs.png") },
          { name: "心理健康", icon: require("../../assets/imgs/20250903/ldt/xljk.png") },
        ],
        carouselList: [
          { name: "AI智能语音交互与个性化反馈，打造沉浸式朗读体验，提升参与感与互动乐趣。", cover: require("../../assets/imgs/20250903/ldt/ldt1.png") },
          { name: "心理释放，辅助分析用户心理状态，提供针对性心理调适建议，促进心理健康。", cover: require("../../assets/imgs/20250903/ldt/ldt2.png") },
          { name: "文本动态跟读对比功能，辅助用户精准掌握朗读节奏与情感表达，优化学习效果。", cover: require("../../assets/imgs/20250903/ldt/ldt3.png") },
          { name: "添加专业级歌唱功能，支持用户自由切换歌唱模式，增强娱乐性与表达多样性。", cover: require("../../assets/imgs/20250903/ldt/ldt4.png") },
          { name: "先进语音识别技术，精准评估发音、语调及语法，助力中英文口语能力科学提升", cover: require("../../assets/imgs/20250903/ldt/ldt5.png") },
        ],
        caseList: [
          { name: "页面", cover: require("../../assets/imgs/20250903/ldt/case1.png") },
          { name: "页面", cover: require("../../assets/imgs/20250903/ldt/case2.png") },
          { name: "页面", cover: require("../../assets/imgs/20250903/ldt/case3.png") },
        ],
			};
		}
	};
</script>

<style scoped>
	.ldt {
		position: relative;
		top: -27vh;
		left: -12vw;
	}
	.title {
		margin-bottom: 8vh;
		margin-top: 2vh;
	}
	.left p,
	.right p {
		text-align: left;
		color: #999999;
    min-height: 72px;
	}
	.left div,
	.right div {
		margin-bottom: 5vh;
	}
	.left img,
	.right img {
		margin-bottom: 2vh;
	}
	.left div {
		text-align: right;
	}
	.right div {
		text-align: left;
	}
	.left,
	.right {
		margin-top: 15vh;
	}
	.bottem {
		margin-top: -18vh;
	}
	.iconlist {
		position: relative;
		top: -28vh;
	}
	.iconlist p {
		margin-top: 2vh;
		font-size: 24px;
		font-weight: bolder;
	}
	.one{
		margin-top: 8vh;
	}
	.three,.four{
		margin-top: 17vh;
	}
	.two {
		background-image: url("../../assets/imgs/swiperback.png");
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.block .name {
		font-size: 30px;
		font-weight: bolder;
	}
	.block .type {
		font-size: 25px;
		font-weight: bolder;
		color: #890101;
	}
	.swiperback {
		float: right;
		position: absolute;
		left: 45vw;
		top: 20vh;
	}
  .carousel-item img{
    height: 743px;
    max-width: 100%;
    object-fit: contain;
  }
  .case-item img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/ldt.vue